import React, { useContext, useState } from "react";
import styled, { css } from "styled-components";
import { useTranslation } from "react-i18next";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
import { TELEMETRY_EVENT_TYPE } from "telemetry/Constants";
import InputProfileForm from "./InputProfileForm";
import InputsManagement from "./InputsManagement";
import { ForwarderWizardContext } from "../ForwarderWizardProvider";
const Breadcrumbs = styled.div(
  ({ theme }) => `
  color: ${theme.colors.variant.default};
  margin-bottom: 20px;
`
);
const Breadcrumb = styled.span(
  ({ $active = false, theme }) => css`
    ${$active ? `color: ${theme.colors.variant.primary};` : ""}
    &:not(:last-child)::after {
      content: '/';
      margin: 0 0.5em;
    }
  `
);
const STEPS = ["create-input-profile", "add-inputs"];
const CreateInputProfile = ({ onCancel, onInputProfileCreated }) => {
  const { t } = useTranslation("enterprise_forwarder");
  const [selectedStep, setSelectedStep] = useState(STEPS[0]);
  const [inputProfile, setInputProfile] = useState(void 0);
  const { setSelectedInputProfile } = useContext(ForwarderWizardContext);
  const sendTelemetry = useSendTelemetry("input-profile");
  const handleInputProfileCreation = (createdInputProfile) => {
    setInputProfile(createdInputProfile);
    setSelectedStep(STEPS[1]);
  };
  const handleInputsCreation = () => {
    sendTelemetry(TELEMETRY_EVENT_TYPE.FORWARDER.FORWARDER_WIZARD_INPUT_PROFILE_SAVED, {
      app_pathname: "forwarder"
    });
    if (!inputProfile) {
      throw new Error("Trying to set Inputs on non-existing Input Profile");
    }
    setSelectedInputProfile(inputProfile);
    onInputProfileCreated(inputProfile);
  };
  switch (selectedStep) {
    // @ts-expect-error fallthrough is on purpose
    case STEPS[1]:
      if (inputProfile) {
        return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Breadcrumbs, null, /* @__PURE__ */ React.createElement(Breadcrumb, null, t("create_input_profile.step_create")), /* @__PURE__ */ React.createElement(Breadcrumb, { $active: true }, t("create_input_profile.step_add_inputs"))), /* @__PURE__ */ React.createElement(InputsManagement, { inputProfile, onInputsCreated: handleInputsCreation }));
      }
    // Let fallthrough if no inputProfile was set
    // eslint-disable-next-line no-fallthrough
    default:
      return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Breadcrumbs, null, /* @__PURE__ */ React.createElement(Breadcrumb, { $active: true }, t("create_input_profile.step_create")), /* @__PURE__ */ React.createElement(Breadcrumb, null, t("create_input_profile.step_add_inputs"))), /* @__PURE__ */ React.createElement(InputProfileForm, { onCancel, onInputProfileCreated: handleInputProfileCreation }));
  }
};
export default CreateInputProfile;
